import { useMemo } from 'react';
import { get } from 'lodash';
import { useGetPackageData } from './useGetPackageData';

export const useGetLabels = () => {
  const { packageData } = useGetPackageData();

  const labels = useMemo(() => {
    return get(packageData, ['labels'], []).slice(0, 3);
  }, [packageData]);

  return { labels };
};
